import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated } from './isAuthenticated';
import { ROUTES } from '../blocks/profileInfo/constant/Routes';

export const PrivateRoute = ({ component: Component, children, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        Component ? <Component {...props} /> : children
      ) : (
        <Redirect
          to={{
            pathname: ROUTES.SIGN_IN,
            state: { from: props.location },
          }}
        />
      )
    }
  />
);
